export const HOME_ROUTE = '/'
export const ABOUT_US_ROUTE = '/about-us'
export const OUR_FARMS_ROUTE = '/our-farms'
export const GALLERY_ROUTE = '/gallery'
export const CONTACT_ROUTE = '/contact'
export const INITIATIVES_ROUTE = '/initiatives'
export const ADMIN_LOGIN_ROUTE = '/admin/login'
export const ADMIN_HOME_ROUTE = '/admin/home'
export const UNSUBSCRIBE_ROUTE = '/unsubscribe'
